module.exports = __webpack_public_path__ + "static/media/iconmanhghep.a8554f52.svg";